module.exports = __webpack_public_path__ + "media/images/malvinas/Sist_Malvinas_Blanco.orig-06c451cce4af8dbc94a5b604694e3bbb.svg";